import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  standalone: true,
  selector: 'iot-platform-ui-timeline-content',
  templateUrl: './timeline-content.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./timeline-content.component.scss']
})
export class TimelineContentComponent {
  visible = input<boolean>(false);
}
